(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (() => {
  const WISHLIST_KEY = 'carybell_wishlist';

  function getWishlist() {
    try {
      const value = localStorage.getItem(WISHLIST_KEY);
      return value ? JSON.parse(value) : [];
    } catch {
      return [];
    }
  }

  function updateWishlistCount() {
    const countElement = document.querySelector(
      '[data-header-wishlist-count]'
    );

    if (!countElement) return;

    const wishlist = getWishlist();
    const count = wishlist.length;

    if (count > 0) {
      countElement.textContent = count;
      countElement.hidden = false;
    } else {
      countElement.textContent = '';
      countElement.hidden = true;
    }
  }

  updateWishlistCount();

  document.addEventListener('carybell:wishlist-change', updateWishlistCount);

  window.addEventListener('storage', (event) => {
    if (event.key === WISHLIST_KEY) {
      updateWishlistCount();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
